// extracted by mini-css-extract-plugin
export default {"changeValue":"bs_gx","positive":"bs_gv","negative":"bs_gw"};